
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/experiences/[...params]",
      function () {
        return require("private-next-pages/stores/experiences/[...params].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/experiences/[...params]"])
      });
    }
  